import styled, { keyframes } from "styled-components";

interface LoadingSpinnerProps {
  isLoading?: boolean;
}

const spin = keyframes`
   100% {
    transform: rotate(360deg);
   }
  `;

const LoadingSpinner = styled.div<LoadingSpinnerProps>`
  width: 20px;
  height: 20px;
  position: absolute;
  opacity: ${({ isLoading }) => (isLoading ? 1 : 0)};
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px solid rgba(255, 255, 255, 0.4);
  border-top-color: ${({ theme }) => theme.colors.baseWhite};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export default LoadingSpinner;
